import { render, staticRenderFns } from "./HomeRaceIcon.vue?vue&type=template&id=02b8a872&scoped=true"
import script from "./HomeRaceIcon.vue?vue&type=script&lang=ts"
export * from "./HomeRaceIcon.vue?vue&type=script&lang=ts"
import style0 from "./HomeRaceIcon.vue?vue&type=style&index=0&id=02b8a872&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b8a872",
  null
  
)

export default component.exports